// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__f5K-K","col":"Table_col__18uog","fulfillmentStatus":"Table_fulfillmentStatus__171lI","emailCol":"Table_emailCol__1cXRD"};